import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { MembershipAwarenessFormData as MembershipAwarenessFormDataType } from '../types';

import {
	MembershipAwarenessFormData,
	type MembershipAwarenessFormDataQuery,
	type MembershipAwarenessFormDataQueryVariables,
} from './getMembershipFormData.graphql';
import { normalize } from './normalize';

export async function getMembershipFormData(utilityContext: UtilityContext): Promise<MembershipAwarenessFormDataType> {
	const {
		gql: { fetch },
	} = utilityContext;

	// still fetched below the page layer; moving it into each page's own pageData query is the follow-up that unblocks server-rendering
	const { data } = await fetch<MembershipAwarenessFormDataQuery, MembershipAwarenessFormDataQueryVariables>({
		query: MembershipAwarenessFormData,
		rejectOnError: true,
	});

	return normalize(utilityContext, data);
}
